import {
  FETCH_PROJECTS,
  FETCH_PROJECTS_SUCCESS,
  FETCH_PROJECTS_ERROR,
  SET_PROJECT,
} from '../actions';

export const fetchProjects = () => ({
  type: FETCH_PROJECTS,
});

export const fetchProjectsSuccess = (data) => ({
  type: FETCH_PROJECTS_SUCCESS,
  payload: {
    data,
  },
});

export const fetchProjectsError = (error) => ({
  type: FETCH_PROJECTS_ERROR,
  payload: {
    error,
  },
});

export const setProject = (data) => ({
  type: SET_PROJECT,
  payload: {
    data,
  },
});
